export const USER_TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'cpf', label: 'CPF', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];
